import React from "react";

const IntroSection = () => {
  return (
    <section className="intro" id="home">
      <h1 className="section__titleBegin section__title--introBegin">
        Hi, I am <strong>Tony Duan</strong>
      </h1>
    </section>
  );
};

export default IntroSection;
